import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// helpers
import {
  addTestimonial as addTestimonialApi,
  updateTestimonial as updateTestimonialApi,
  getTestimonial as getTestimonialApi,
  deleteTestimonial as deleteTestimonialApi,
} from "../../helpers/";

// actions
import {
  testimonialApiResponseSuccess,
  testimonialApiResponseError,
  getTestimonial,
} from "./actions";

// constants
import { TestimonialActionTypes } from "./constants";

interface testimonialData {
  payload: {
    id: number;
    rating: string;
    comment_en: string;
    comment_ar: string;
    user_name: string;
    user_name_ar: string;
    courseId: string;
  };
  type: string;
}

function* createTestimonial({
  payload: {
    rating,
    comment_en,
    comment_ar,
    user_name,
    user_name_ar,
    courseId,
  },
  type,
}: testimonialData): SagaIterator {
  try {
    const response = yield call(addTestimonialApi, {
      rating,
      comment_en,
      comment_ar,
      user_name,
      user_name_ar,
      courseId,
    });

    const testimonialData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      testimonialApiResponseSuccess(
        TestimonialActionTypes.CREATE_TESTIMONIAL,
        testimonialData
      )
    );
    yield put(getTestimonial());
  } catch (error: any) {
    yield put(
      testimonialApiResponseError(
        TestimonialActionTypes.CREATE_TESTIMONIAL,
        error
      )
    );
  }
}

function* updateTestimonial({
  payload: {
    id,
    rating,
    comment_en,
    comment_ar,
    user_name,
    user_name_ar,
    courseId,
  },
}: testimonialData): SagaIterator {
  try {
    const response = yield call(updateTestimonialApi, id, {
      rating,
      comment_en,
      comment_ar,
      user_name,
      user_name_ar,
      courseId,
    });
    const testimonialData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      testimonialApiResponseSuccess(
        TestimonialActionTypes.UPDATE_TESTIMONIAL,
        testimonialData
      )
    );
    yield put(getTestimonial());
  } catch (error: any) {
    yield put(
      testimonialApiResponseError(
        TestimonialActionTypes.UPDATE_TESTIMONIAL,
        error
      )
    );
  }
}

function* getTestimonials(): SagaIterator {
  try {
    const response = yield call(getTestimonialApi);
    const testimonialData = response?.data?.testimonials;

    yield put(
      testimonialApiResponseSuccess(
        TestimonialActionTypes.GET_TESTIMONIAL,
        testimonialData
      )
    );
  } catch (error: any) {
    yield put(
      testimonialApiResponseError(TestimonialActionTypes.GET_TESTIMONIAL, error)
    );
  }
}

function* deleteTestimonial({
  payload: { id },
}: testimonialData): SagaIterator {
  try {
    const response = yield call(deleteTestimonialApi, id);
    const testimonialData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      testimonialApiResponseSuccess(
        TestimonialActionTypes.DELETE_TESTIMONIAL,
        testimonialData
      )
    );
    yield put(getTestimonial());
  } catch (error: any) {
    yield put(
      testimonialApiResponseError(
        TestimonialActionTypes.DELETE_TESTIMONIAL,
        error
      )
    );
  }
}

export function* watchCreateTestimonial() {
  yield takeEvery(TestimonialActionTypes.CREATE_TESTIMONIAL, createTestimonial);
}
export function* watchUpdateTestimonial() {
  yield takeEvery(TestimonialActionTypes.UPDATE_TESTIMONIAL, updateTestimonial);
}
export function* watchGetTestimonial() {
  yield takeEvery(TestimonialActionTypes.GET_TESTIMONIAL, getTestimonials);
}
export function* watchDeleteTestimonial() {
  yield takeEvery(TestimonialActionTypes.DELETE_TESTIMONIAL, deleteTestimonial);
}

function* TestimonialSaga() {
  yield all([
    fork(watchCreateTestimonial),
    fork(watchUpdateTestimonial),
    fork(watchDeleteTestimonial),
    fork(watchGetTestimonial),
  ]);
}

export default TestimonialSaga;
